import { EventCategoryShortListItem } from 'model/modules/events/eventCategory';
import AppCard from 'presentation/components/shared/card/AppCard';
import SidebarMenuList from 'presentation/components/shared/sidebar/menu/SidebarMenuList';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import privateChannelIcon from 'assets/img/icons/private-channel-3d.png';

interface Props {
  categories: EventCategoryShortListItem[];
  activeCategoryId?: ID;
  hasAccessToPrivateChannel: boolean;
}

const EventDetailCategories: FC<Props> = ({
  categories,
  activeCategoryId,
  hasAccessToPrivateChannel,
}) => {
  const navigate = useNavigate();

  const location = useLocation();

  const { t } = useTranslation();

  return (
    <AppCard display="flex" flexDir="column" w="100%">
      <SidebarMenuList
        items={[
          ...(hasAccessToPrivateChannel
            ? [
                {
                  onClick: () => navigate(AppRoute.privateChannel),
                  text: t('privateChannel'),
                  isActive: location.pathname.startsWith(
                    AppRoute.privateChannel
                  ),
                  icon: privateChannelIcon,
                  iconSize: '38px',
                },
              ]
            : []),
          ...categories.map((category) => ({
            onClick: () => navigate(AppRoute.events(category.id)),
            text: category.name,
            icon: category.icon,
            iconSize: '38px',
            isActive: category.id === activeCategoryId,
          })),
        ]}
      />
    </AppCard>
  );
};

export default EventDetailCategories;
